'use client';

import { clsx } from 'clsx';
import { usePathname } from 'next/navigation';
import { FC, ReactNode, useEffect, useRef } from 'react';

import { Link } from '@/general/components/Link/Link';

interface Props {
  href: string;
  title: ReactNode;
}

export const ContentHubHeroNavLink: FC<Props> = ({ href, title }) => {
  const pathname = usePathname();
  const ref = useRef<HTMLLIElement>(null);
  const isActive = getIsActive(href, pathname);

  // Horizontally scroll to the element so it's in the view
  useEffect(() => {
    if (isActive && ref.current && typeof ref.current.parentElement?.scroll !== 'undefined') {
      const windowWidth = window.innerWidth;
      const elementOffsetLeft = ref.current.offsetLeft;
      const elementOffsetRight = elementOffsetLeft + ref.current.clientWidth;
      const parentScroll = ref.current.parentElement.scrollLeft;
      if (elementOffsetRight - parentScroll > windowWidth || elementOffsetLeft - parentScroll < 0) {
        ref.current.parentElement?.scroll({ left: ref.current.offsetLeft });
      }
    }
  }, [isActive]);

  return (
    <li className="shrink-0 snap-start" ref={ref}>
      <Link
        href={href}
        className={clsx('c-fs-body1 transition-border block border-b-2 px-4 py-3 no-underline duration-200', {
          ['font-extrabold']: isActive,
          ['border-transparent hover:border-tex-def-tie3 focus-visible:border-tex-def-tie3']: !isActive,
        })}
      >
        {title}
      </Link>
    </li>
  );
};

const getIsActive = (href: string, pathname: string) => {
  if (href === '/street-smarts') {
    return pathname === '/street-smarts' || pathname?.match(/^\/street-smarts\/\d+$/);
  }

  return !!pathname?.startsWith(href);
};
